import { usePrimaryPage } from '@/PageManager'
import { useAtomValue } from 'jotai'
import { hideConversationsAtom } from '@/atoms/preferences'
import { HugeiconsIcon } from '@hugeicons/react'
import { Comment } from '@hugeicons/core-free-icons'
import BottomNavigationBarItem from './BottomNavigationBarItem'

export default function ConversationsButton() {
  const { navigate, current, display } = usePrimaryPage()
  const hideConversations = useAtomValue(hideConversationsAtom)
  if (hideConversations) return null

  return (
    <BottomNavigationBarItem
      active={current === 'conversations' && display}
      onClick={() => navigate('conversations')}
    >
      <HugeiconsIcon icon={Comment} />
    </BottomNavigationBarItem>
  )
}
